import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

export default {
  logoContainer: (theme: Theme): SerializedStyles => css`
    label: logoContainer;
    text-align: center;
    margin: ${theme.mui.spacing(3)}px auto;
    width: ${theme.mui.spacing(15)}px;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  `,
  cardContainer: (theme: Theme) => css`
    // When using card selector, different card images maybe loaded after page
    // load. During load, we display a spinner, which could be much shorter than
    // card. Set the container to be a fixed height in this case so that the
    // page does not shuffle when switching between spinner and card image.
    height: ${theme.mui.spacing(15)}px;
  `,

  spinner: (): SerializedStyles => css`
    margin: auto;
  `,

  logo: (): SerializedStyles => css`
    margin: auto;
  `,
};
